import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { FaPuzzlePiece, FaCheckCircle, FaLightbulb, FaBook, FaInfoCircle } from 'react-icons/fa';
import { API_URL } from './config';

// ??????? Logic
import { generateMaze, solveMaze } from './mazeLogic';
import { generateSudoku } from './sudokuLogic';
import { generateWordSearch } from './wordSearchLogic';
import { generateMathQuiz } from './mathLogic';
import { generateScramble } from './wordScrambleLogic';
import { generatePyramid } from './numberPyramidLogic';

// ==========================================
// 1. ????? ????? (Canvas Drawing)
// ==========================================

const drawSudoku = (ctx, { seed, difficulty }) => {
  const { puzzle, solution } = generateSudoku(difficulty, seed);
  const cellSize = 35;
  const size = 9 * cellSize;
  ctx.canvas.width = size; ctx.canvas.height = size;
  ctx.fillStyle = 'white'; ctx.fillRect(0, 0, size, size);
  ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.font = 'bold 16px Arial';

  for (let r = 0; r < 9; r++) {
    for (let c = 0; c < 9; c++) {
      const x = c * cellSize; const y = r * cellSize;
      ctx.strokeStyle = '#dfe6e9'; ctx.strokeRect(x, y, cellSize, cellSize);
      ctx.fillStyle = puzzle[r][c] !== 0 ? '#2d3436' : '#d63031';
      ctx.fillText(solution[r][c], x + cellSize/2, y + cellSize/2);
    }
  }
  ctx.strokeStyle = '#2d3436'; ctx.lineWidth = 2; ctx.beginPath();
  for (let i = 0; i <= 9; i += 3) {
    ctx.moveTo(i * cellSize, 0); ctx.lineTo(i * cellSize, size);
    ctx.moveTo(0, i * cellSize); ctx.lineTo(size, i * cellSize);
  }
  ctx.stroke();
};

const drawMaze = (ctx, settings) => {
  const { seed, difficulty = 'medium' } = settings;
  const mazeData = generateMaze(difficulty, seed);
  const { maze, width, height } = mazeData;
  const path = solveMaze(mazeData);

  const FIXED_WIDTH = 350;
  const cellSize = FIXED_WIDTH / width;
  ctx.canvas.width = FIXED_WIDTH;
  ctx.canvas.height = height * cellSize;

  ctx.fillStyle = 'white'; ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  
  // ??? ?????? (Path)
  ctx.beginPath();
  ctx.strokeStyle = '#ff7675';
  ctx.lineWidth = cellSize / 2.5;
  if (path.length > 0) {
    ctx.moveTo(path[0].x * cellSize + cellSize/2, path[0].y * cellSize + cellSize/2);
    for (let cell of path) ctx.lineTo(cell.x * cellSize + cellSize/2, cell.y * cellSize + cellSize/2);
  }
  ctx.stroke();

  // ??? ???????
  ctx.strokeStyle = '#2d3436';
  ctx.lineWidth = (difficulty === 'expert' || difficulty === 'hard') ? 1 : 1.5;
  ctx.beginPath();
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const cell = maze[y][x];
      const px = x * cellSize; const py = y * cellSize;
      if (cell.top) { ctx.moveTo(px, py); ctx.lineTo(px + cellSize, py); }
      if (cell.right) { ctx.moveTo(px + cellSize, py); ctx.lineTo(px + cellSize, py + cellSize); }
      if (cell.bottom) { ctx.moveTo(px + cellSize, py + cellSize); ctx.lineTo(px, py + cellSize); }
      if (cell.left) { ctx.moveTo(px, py + cellSize); ctx.lineTo(px, py); }
    }
  }
  ctx.stroke();

  // ?????? ??????? ????????
  ctx.fillStyle = '#00b894'; ctx.beginPath(); ctx.arc(cellSize/2, cellSize/2, cellSize/4, 0, 2*Math.PI); ctx.fill();
  ctx.fillStyle = '#d63031'; ctx.beginPath(); ctx.arc((width-1)*cellSize + cellSize/2, (height-1)*cellSize + cellSize/2, cellSize/4, 0, 2*Math.PI); ctx.fill();
};

// ? ??????? ???? WordSearch ??? ???? ?? Themes ? ?????????
const drawWordSearch = (ctx, settings) => {
  const { seed, words, difficulty = 'medium' } = settings;
  
  // 1. ????? ???? ??????? (Array) ?? ??? ???????? ???????
  const wordsList = typeof words === 'string' 
    ? words.split(',').map(w => w.trim()) 
    : (words || ['PUZZLIFY']);

  // 2. ????? ???? ?????? ????? ??? ??????? ??? ????? ????? ???? ?????
  const gridSize = difficulty === 'easy' ? 10 : (difficulty === 'medium' ? 12 : 15);
  
  const { grid, placedWords } = generateWordSearch(gridSize, wordsList, seed);
  const cellSize = 30;
  const dim = gridSize * cellSize;
  
  ctx.canvas.width = dim; 
  ctx.canvas.height = dim;
  ctx.fillStyle = 'white'; 
  ctx.fillRect(0, 0, dim, dim);
  ctx.font = 'bold 16px Arial'; 
  ctx.textAlign = 'center'; 
  ctx.textBaseline = 'middle';

  // ??? ??????
  grid.forEach((row, r) => row.forEach((char, c) => {
    ctx.fillStyle = '#636e72'; 
    ctx.fillText(char, c * cellSize + cellSize/2, r * cellSize + cellSize/2);
  }));

  // ??? ??????? ??? ??????
  ctx.lineWidth = 22; 
  ctx.lineCap = 'round'; 
  ctx.globalAlpha = 0.4;
  placedWords.forEach(({ start, end }) => {
    ctx.beginPath(); 
    ctx.strokeStyle = '#fdcb6e';
    ctx.moveTo(start.c * cellSize + cellSize/2, start.r * cellSize + cellSize/2);
    ctx.lineTo(end.c * cellSize + cellSize/2, end.r * cellSize + cellSize/2);
    ctx.stroke();
  });
  ctx.globalAlpha = 1.0;
};

const drawMath = (ctx, { seed, difficulty }) => {
  const quiz = generateMathQuiz(16, difficulty, seed);
  ctx.canvas.width = 400; ctx.canvas.height = 550;
  ctx.fillStyle = 'white'; ctx.fillRect(0, 0, 400, 550);
  ctx.font = 'bold 18px Courier New'; ctx.textAlign = 'left';

  let x = 30, y = 50;
  quiz.forEach((q, i) => {
    ctx.fillStyle = '#2d3436';
    ctx.fillText(`${q.num1} ${q.operator} ${q.num2} = `, x, y);
    ctx.fillStyle = '#d63031';
    ctx.fillText(`${q.answer}`, x + 130, y);
    y += 40;
    if (i === 7) { x = 230; y = 50; }
  });
};

const drawWordScramble = (ctx, { seed }) => {
  const puzzles = generateScramble(8, null, seed);
  ctx.canvas.width = 500; ctx.canvas.height = 450;
  ctx.fillStyle = 'white'; ctx.fillRect(0, 0, 500, 450);
  ctx.font = '20px Courier New'; ctx.textAlign = 'left';
  let y = 60;
  puzzles.forEach((p) => {
    ctx.fillStyle = '#636e72'; ctx.fillText(`${p.scrambled}`, 50, y);
    ctx.fillStyle = '#d63031'; ctx.fillText(`?  ${p.original}`, 260, y);
    y += 45;
  });
};

const drawPyramid = (ctx, { seed }) => {
  const { solution } = generatePyramid(4, 'medium', seed);
  const brickW = 70; const brickH = 45;
  const levels = solution.length;
  ctx.canvas.width = levels * brickW + 60; ctx.canvas.height = levels * brickH + 80;
  ctx.fillStyle = 'white'; ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  ctx.font = 'bold 18px Arial'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  ctx.strokeStyle = '#2d3436'; ctx.lineWidth = 2;
  const startY = 40; const centerX = ctx.canvas.width / 2;

  solution.forEach((row, r) => {
    const startX = centerX - (row.length * brickW / 2);
    row.forEach((val, c) => {
      const x = startX + c * brickW; const y = startY + r * brickH;
      ctx.strokeRect(x, y, brickW, brickH);
      ctx.fillStyle = '#d63031'; ctx.fillText(val, x + brickW/2, y + brickH/2);
    });
  });
};

// ==========================================
// 2. ???? ???? ?????? (SingleSolution)
// ==========================================
const SingleSolution = ({ page, index }) => {
  const [isRevealed, setIsRevealed] = useState(false);
  const canvasRef = useRef(null);
  const { type, settings } = page;

  useEffect(() => {
    if (isRevealed && canvasRef.current && settings) {
      const ctx = canvasRef.current.getContext('2d');
      if (type === 'Sudoku') drawSudoku(ctx, settings);
      else if (type === 'Maze') drawMaze(ctx, settings);
      else if (type === 'WordSearch') drawWordSearch(ctx, settings);
      else if (type === 'Math') drawMath(ctx, settings);
      else if (type === 'WordScramble') drawWordScramble(ctx, settings);
      else if (type === 'NumberPyramid') drawPyramid(ctx, settings);
    }
  }, [isRevealed, page]);

  return (
    <div style={{ 
      background: 'white', borderRadius: '12px', overflow: 'hidden', 
      width: '100%', maxWidth: '600px', border: '1px solid #e0e0e0', 
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)', marginBottom: '20px' 
    }}>
      <div 
        onClick={() => setIsRevealed(!isRevealed)} 
        style={{ 
          padding: '18px 25px', background: isRevealed ? '#6c5ce7' : 'white', 
          color: isRevealed ? 'white' : '#2d3436', cursor: 'pointer', 
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          transition: 'all 0.3s ease'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <FaPuzzlePiece size={18} opacity={0.7} />
          <span style={{ fontSize: '1.1rem', fontWeight: '700' }}>Page {index + 1}: {type}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {isRevealed ? <FaLightbulb /> : <FaCheckCircle color="#00b894" />}
          <span style={{ fontSize: '0.9rem' }}>{isRevealed ? 'Hide' : 'Show Solution'}</span>
        </div>
      </div>

      {isRevealed && (
        <div style={{ padding: '30px', display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#fcfcfc', borderTop: '1px solid #eee' }}>
          <div style={{ padding: '15px', background: 'white', borderRadius: '10px', boxShadow: 'inset 0 0 10px rgba(0,0,0,0.05)' }}>
            <canvas ref={canvasRef} style={{ maxWidth: '100%', height: 'auto', display: 'block' }} />
          </div>
          <div style={{ marginTop: '15px', display: 'flex', alignItems: 'center', gap: '5px', color: '#b2bec3', fontSize: '13px' }}>
             <FaInfoCircle size={12} />
             <span>Difficulty: {settings.difficulty || 'Normal'}</span>
          </div>
        </div>
      )}
    </div>
  );
};

// ==========================================
// 3. ??????? ??????? (SolutionViewer)
// ==========================================
const SolutionViewer = () => {
  const [searchParams] = useSearchParams();
  const bookId = searchParams.get('bookId');
  const [bookData, setBookData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (bookId) {
      axios.get(`${API_URL}/books/${bookId}`)
        .then(res => { setBookData(res.data); setLoading(false); })
        .catch(err => { console.error(err); setLoading(false); });
    } else { setLoading(false); }
  }, [bookId]);

  if (!bookId) return <div style={centerStyle}><FaBook size={40} /> No Book ID Provided</div>;
  if (loading) return <div style={centerStyle}><div className="spinner"></div> Loading Solutions...</div>;
  if (!bookData) return <div style={centerStyle}>? Book Not Found</div>;

  return (
    <div style={{ padding: '40px 20px', background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', minHeight: '100vh', fontFamily: "'Segoe UI', Roboto, sans-serif" }}>
      <div style={{ textAlign: 'center', marginBottom: '50px' }}>
        <h1 style={{ color: '#2d3436', fontSize: '2.5rem', marginBottom: '10px', fontWeight: '900' }}>?? Solution Key</h1>
        <p style={{ color: '#636e72', fontSize: '16px', letterSpacing: '1px' }}>Book ID: <span style={{color: '#6c5ce7', fontWeight: 'bold'}}>{bookId}</span></p>
        <div style={{ width: '60px', height: '4px', background: '#6c5ce7', margin: '20px auto', borderRadius: '2px' }}></div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: '60px' }}>
        {bookData.pages.map((page, index) => (
          <SingleSolution key={index} page={page} index={index} />
        ))}
      </div>
      
      <div style={{ textAlign: 'center', color:'#636e72', fontSize:'14px', borderTop: '1px solid rgba(0,0,0,0.1)', paddingTop: '20px' }}>
        Generated by <strong>Puzzlify.net</strong>
      </div>

      <style>{`
        .spinner { border: 4px solid rgba(0, 0, 0, 0.1); width: 36px; height: 36px; border-radius: 50%; border-left-color: #6c5ce7; animation: spin 1s linear infinite; margin-bottom: 15px; }
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
};

const centerStyle = { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '1.4rem', color: '#2d3436', fontWeight: '600' };

export default SolutionViewer;